export default function isLocationValidForApproval(service) {
  if (!service.location) return false;
  return (
    !!service.location.countryCode &&
    !!service.location.areaLevelOne &&
    service.location.address !== "" &&
    service.location.latLng.lat !== "" &&
    service.location.latLng.lng !== ""
  );
}

export function checkJobLocation(job) {
  if (job.locationType === "Remote") {
    return {
      isRemote: true,
      isLocationValid: false,
      isListedLocationValid: false,
    };
  }
  const isLocationValid =
    (!job.isLocationHidden &&
      !!job.location?.address &&
      !!job.location?.latLng.lat &&
      !!job.location?.latLng.lng &&
      !!job.location?.countryCode &&
      !!job.location?.country) ||
    (job.isLocationHidden &&
      !!job.location?.address &&
      !!job.location?.countryCode &&
      !!job.location?.country);
  const isListedLocationValid =
    !!job.listedLocation?.address &&
    !!job.listedLocation?.city &&
    !!job.listedLocation?.countryCode &&
    !!job.listedLocation?.country;
  return { isRemote: false, isLocationValid, isListedLocationValid };
}
